<template>
  <div class="mes_div">
    <button class="mes_but_1"><i class="iconfont icon-xiaoxi"></i></button>
    <div class="info_div">
      <span>{{ mesContent }}</span>
    </div>
    <div class="but_div">
      <button class="mes_but_2"><i class="iconfont icon-youyou-"></i></button>
      <button class="mes_but_2"><i class="iconfont icon-gengduo2"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "message.vue",
  data() {
    return {
      mesContent: "..."
    }
  },
  computed: {},
  methods: {}
}
</script>

<style scoped>
.mes_div {
  height: 3rem;
  width: 58.9rem;
  /* background-image: url("../../assets/images/mes_bag.png"); */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  line-height: 3rem;
}

.mes_but_1 {
  color: #00dafc;
  margin-left: 2.5rem;
  margin-right: 0.5rem;
}

.mes_but_1 i {
  font-size: 1.6rem;
}

.but_div {
  float: right;
}

.mes_but_2 {
  color: #00dafc;
  margin-right: 1.5rem;
  cursor: pointer;
}

.mes_but_2:first-child {
  margin-right: 1rem;
}

.mes_but_2 i {
  font-size: 1.4rem;
}

.mes_but_2:hover {
  color: #0f98c7;
}

.info_div {
  position: absolute;
  width: 48rem;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #00dafc;
  line-height: 2.7rem;
}

</style>